import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.NotUploadedVertaforeStatusList.IRequest;
type Response = Api.Core.Contract.NotUploadedVertaforeStatusList.IResponse;
type Headers = Api.Core.Contract.NotUploadedVertaforeStatusList.IHeaders;
const url = '/api/Sales/Contract/NotUploadedVertaforeStatus';
export default async function contractNotUploadedVertaforeStatusListApi(): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    headers: getDefaultHeaders(),
  });
}
